import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const messageDirectionSchema = z.enum(['in', 'out']);
export const messageSenderKindSchema = z.enum(['contact', 'user', 'bot', 'system']);
export const messageVisibilitySchema = z.enum(['public', 'internal_note']);

export const attachmentSchema = z.object({
  id: idSchema,
  filename: z.string().max(512),
  mime_type: z.string().max(128),
  size_bytes: z.number().int().nonnegative(),
  url: z.string().url().nullable().optional(),
  thumbnail_url: z.string().url().nullable().optional(),
  width: z.number().int().nullable().optional(),
  height: z.number().int().nullable().optional(),
  duration_sec: z.number().int().nullable().optional(),
});
export type Attachment = z.infer<typeof attachmentSchema>;

export const messageSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  ticket_id: idSchema,
  direction: messageDirectionSchema,
  sender_kind: messageSenderKindSchema,
  sender_user_id: idSchema.nullable().optional(),
  sender_contact_id: idSchema.nullable().optional(),
  channel_id: idSchema.nullable().optional(),
  external_id: z.string().nullable().optional(),
  body: z.string().nullable(),
  body_html: z.string().nullable().optional(),
  visibility: messageVisibilitySchema,
  mentions: z.array(idSchema).default([]),
  quick_replies: z.array(z.object({ id: z.string(), label: z.string() })).default([]),
  meta: jsonMetaSchema.default({}),
  attachments: z.array(attachmentSchema).default([]),
  sent_at: isoDateSchema,
  delivered_at: isoDateSchema.nullable().optional(),
  read_at: isoDateSchema.nullable().optional(),
  edited_at: isoDateSchema.nullable().optional(),
  deleted_at: isoDateSchema.nullable().optional(),
});
export type Message = z.infer<typeof messageSchema>;

export const sendMessageSchema = z.object({
  body: z.string().min(1).max(50000),
  visibility: messageVisibilitySchema.default('public'),
  attachments: z.array(idSchema).max(20).optional(), // ID уже загруженных через POST /attachments
  template_id: idSchema.optional(),
  template_vars: z.record(z.unknown()).optional(),
  quick_replies: z.array(z.object({ id: z.string(), label: z.string() })).optional(),
  mentions: z.array(idSchema).optional(),
  meta: jsonMetaSchema.optional(),
});

export const typingIndicatorSchema = z.object({
  ticket_id: idSchema,
  is_typing: z.boolean(),
});
